<template>
  <el-container>
    <main class="tab__container">
      <h2 class="page__title">
        DVR сервер:
        <span style="color: black">{{ server.server_domain }}</span>
      </h2>
      <el-tabs v-model="activeTab">
        <el-tab-pane v-for="(tab, i) in components" :name="tab.key" :label="tab.name" :key="i">
          <component :is="tab.component" :get-server-data="getServerData" />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>
<script>
import ServerEdit from "@/components/Server/tabs/ServerEdit";
import ReserveTransfersList from "@/components/Server/tabs/ReserveTransfersList/ReserveTransfersList";
import { mapActions, mapState } from "vuex";

export default {
  name: "Server",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      activeTab: "edit",
      components: [
        {
          name: "Настройки сервера",
          key: "edit",
          component: ServerEdit,
        },
      ],
    };
  },
  computed: {
    ...mapState("server", {
      server: (state) => state.server,
    }),
  },
  watch: {
    server() {
      this.components = [
        {
          name: "Настройки сервера",
          key: "edit",
          component: ServerEdit,
        },
        {
          name: "Отчеты автоматического резервирования",
          key: "reserve-transfers",
          component: ReserveTransfersList,
        },
      ]
    }
  },
  created() {
    this.getServerData();
  },
  methods: {
    ...mapActions("server", {
      getServer: "GET_SERVER",
    }),
    getServerData() {
      this.getServer(this.id)
        .catch(() => {
          const url = `/servers/1`;
          window.location.replace(url);
        });
    }
  },
};
</script>
